import { render, staticRenderFns } from "./ZDJPage.vue?vue&type=template&id=06f067ca"
import script from "./ZDJPage.vue?vue&type=script&lang=js"
export * from "./ZDJPage.vue?vue&type=script&lang=js"
import style0 from "./ZDJPage.vue?vue&type=style&index=0&id=06f067ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports